import { createContext, useContext, useState } from "react";
import { UseDiscountCode } from "../Services/DiscountService";
import { useConfig } from "./ConfigProvider";
import { useAuth } from "./AuthProvider";
import { toast } from "react-toastify";

const DiscountContext = createContext()

export const useDiscount = () => {
    return useContext(DiscountContext)
}

export const DiscountProvider = ({ children }) => {
    const { api } = useConfig()
    const { authState } = useAuth()

    const [voucher, setVoucher] = useState(() => {
        const stored = localStorage.getItem('voucher')
        return stored === 'null' ? null : stored
    })

    const [voucherConditions, setVoucherConditions] = useState(() => {
        try {
            const stored = localStorage.getItem('voucherConditions')
            return stored ? JSON.parse(stored) : { discount: -1, minValue: -1 }
        } catch (e) {
            localStorage.setItem('voucherConditions', JSON.stringify({ discount: -1, minValue: -1 }))
            return { discount: -1, minValue: -1 }
        }
    })

    const handleUseVoucher = async (voucherParam) => {
        if (!voucherParam || voucherParam.trim() == '') {
            toast.warning('Kod rabatowy nie może byc psuty!')
            return false
        }
        try {
            const res = await UseDiscountCode(api, voucherParam, authState.custId)
            const voucherData = res.data
            if (voucherData.isActive && voucherData.isValid) {
                setVoucher(voucherParam)
                setVoucherConditions({ discount: voucherData.discount, minValue: voucherData.minValue })
                localStorage.setItem('voucher', voucherParam)
                localStorage.setItem('voucherConditions', JSON.stringify({ discount: voucherData.discount, minValue: voucherData.minValue }))
                return true
            }
            else {
                setVoucher(null)
                localStorage.setItem('voucher', null)
                localStorage.setItem('voucherConditions', JSON.stringify({ discount: -1, minValue: -1 }))
                setVoucherConditions({ discount: -1, minValue: -1 })
                toast.warning(voucherData.validationMsg)
                return false
            }
        } catch (error) {
            setVoucher(null)
            localStorage.setItem('voucher', null)
            localStorage.setItem('voucherConditions', JSON.stringify({ discount: -1, minValue: -1 }))
            setVoucherConditions({ discount: -1, minValue: -1 })
            toast.error('Błąd w trakcie weryfikacji kodu rabatowego!')
            console.log(error)
            return false
        }
    }

    const handleClearVoucher = () => {
        setVoucher(null)
        setVoucherConditions({ discount: -1, minValue: -1 })
        localStorage.setItem('voucher', null)
        localStorage.setItem('voucherConditions', JSON.stringify({ discount: -1, minValue: -1 }))
    }

    return (
        <DiscountContext.Provider value={{
            voucher,
            voucherConditions,
            handleUseVoucher,
            handleClearVoucher
        }}>
            {children}
        </DiscountContext.Provider>
    )
}